/* BLU UI: grupo flutuante de WhatsApp e Instagram.
   Lê os links dos botões flutuantes que o tema injeta no <body> (.instagram-float e o link do WhatsApp com imagem fixa),
   esconde os dois e cria um grupo novo (.blu-fab) com os mesmos endereços.
   Para subir o grupo acima de uma barra fixa: document.documentElement.classList.add('blu-fab-up')
   e, se quiser, --blu-fab-lift no <html> (padrão 84px). Para esconder: classe blu-fab-hide.
   Atalho: window.BLUfab.up(px) / .down() / .hide(true|false) */
(function () {
  if (window.BLUfab) return;
  var D = document, H = D.documentElement;
  H.classList.add('blu-fab-on');

  var WA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.79h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.89 9.88zm8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41z"/></svg>';
  var IG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5.3"/><circle cx="12" cy="12" r="4.1"/><circle cx="17.3" cy="6.7" r="1.3" fill="#fff" stroke="none"/></svg>';
  var Q = 'a.instagram-float,a[href*="instagram.com"],a[href*="wa.me"],a[href*="api.whatsapp"],a[href*="whatsapp.com"]';

  function fixed(el) { return !!el && getComputedStyle(el).position === 'fixed'; }
  /* só os flutuantes: o próprio link é fixo, ou a imagem dentro dele é fixa */
  function isFloat(a) {
    if (a.closest('.blu-fab')) return false;
    if (a.classList.contains('instagram-float') || fixed(a)) return true;
    var im = a.querySelector('img,svg');
    return fixed(im);
  }
  function find() {
    var r = { wa: null, ig: null, src: [] };
    Array.prototype.forEach.call(D.querySelectorAll(Q), function (a) {
      if (!isFloat(a)) return;
      var h = a.getAttribute('href') || '';
      if (/wa\.me|whatsapp/i.test(h)) { if (!r.wa) r.wa = h; }
      else if (/instagram\.com/i.test(h) || a.classList.contains('instagram-float')) { if (!r.ig) r.ig = h; }
      else return;
      r.src.push(a);
    });
    return r;
  }
  function btn(kind, href, label, tip, svg) {
    var a = D.createElement('a');
    a.className = 'blu-fab__b blu-fab__b--' + kind;
    a.href = href; a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', label);
    a.innerHTML = svg + '<span class="blu-fab__t" aria-hidden="true">' + tip + '</span>';
    return a;
  }
  var box = null;
  function build() {
    if (box && D.body.contains(box)) return true;
    var f = find();
    if (!f.wa && !f.ig) return false;
    f.src.forEach(function (a) { a.classList.add('blu-fab-src'); a.setAttribute('aria-hidden', 'true'); a.setAttribute('tabindex', '-1'); });
    box = D.createElement('div');
    box.className = 'blu-fab';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Fale com a BLU');
    if (f.ig) box.appendChild(btn('ig', f.ig, 'Instagram da BLU (abre em nova aba)', 'Instagram', IG));
    if (f.wa) box.appendChild(btn('wa', f.wa, 'Fale com a BLU no WhatsApp (abre em nova aba)', 'WhatsApp', WA));
    D.body.appendChild(box);
    try { D.dispatchEvent(new CustomEvent('blu:fab:ready')); } catch (e) {}
    return true;
  }
  function start() {
    var ok = false;
    try { ok = build(); } catch (e) { ok = false; }
    if (ok) return;
    /* o tema pode injetar os botões um pouco depois: tenta de novo no load */
    window.addEventListener('load', function () {
      var ok2 = false;
      try { ok2 = build(); } catch (e) { ok2 = false; }
      if (!ok2) H.classList.remove('blu-fab-on');
    });
  }

  window.BLUfab = {
    el: function () { return box; },
    up: function (px) { if (px != null) H.style.setProperty('--blu-fab-lift', Math.max(0, Math.round(px)) + 'px'); H.classList.add('blu-fab-up'); },
    down: function () { H.classList.remove('blu-fab-up'); },
    hide: function (on) { H.classList.toggle('blu-fab-hide', on !== false); }
  };

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();

/* BLU UI: confiança no carrinho. Responde as duas dúvidas de quem está para pagar:
   quando chega e se é seguro. Entra logo abaixo do botão de finalizar (gaveta e página /cart). */
(function () {
  if (window.__bluTrust) return; window.__bluTrust = 1;
  var D = document;
  var I = {
    box: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>'
  };
  var HTML = '<ul class="blu-trust" aria-label="Sobre a entrega e o pagamento">' +
    '<li>' + I.box + '<span><b>Postado em até 1 dia útil</b>, com rastreio no seu WhatsApp</span></li>' +
    '<li>' + I.lock + '<span><b>Pagamento seguro</b> no Pix, cartão ou boleto</span></li>' +
    '<li>' + I.back + '<span><b>7 dias para desistir</b> depois de receber</span></li>' +
    '</ul>';
  function place(root) {
    if (!root || root.querySelector('.blu-trust')) return;
    var b = null, list = root.querySelectorAll('button,a,[name="checkout"]');
    for (var i = 0; i < list.length; i++) { if (/finalizar|checkout/i.test(list[i].textContent || '') || list[i].getAttribute('name') === 'checkout') { b = list[i]; break; } }
    if (!b) return;
    var host = b.closest('.push-btn') || b;
    host = host.parentElement && host.parentElement.classList.contains('relative') ? host.parentElement : host;
    host.insertAdjacentHTML('afterend', HTML);
  }
  function run() {
    place(D.querySelector('#right-drawer-slot .pb-safe-bottom'));
    var f = D.querySelector('form#cart');
    if (f && !D.querySelector('#right-drawer-slot form#cart') ) place(f.closest('section') || f);
  }
  var t = 0;
  function soon() { if (t) return; t = setTimeout(function () { t = 0; try { run(); } catch (e) {} }, 120); }
  function start() {
    soon();
    var slot = D.querySelector('#right-drawer-slot') || D.body;
    if ('MutationObserver' in window) new MutationObserver(soon).observe(slot, { childList: true, subtree: true });
    D.addEventListener('theme:update:cart', soon);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();

/* BLU UI: total do checkout na gaveta do carrinho.
   Quando a caixa mistura sabores, o carrinho da Shopify não soma os potes para o desconto progressivo
   (o app só junta o mesmo produto), mas o checkout soma. Aqui calculamos o que o checkout vai cobrar,
   pela mesma regra dele, e mostramos uma linha acima do botão de finalizar quando fica mais barato. */
(function () {
  if (window.__bluCkt) return; window.__bluCkt = 1;
  var D = document;
  var POTE = { 46555319107796: 1, 48343557406932: 1 }; /* Blueberry, Framboesa */
  var PLAN = { 4859396308: 1200, 8915747028: 556, 8915779796: 353 }; /* desconto da assinatura por plano (em centésimos de %) */
  function brl(c) { var s = (Math.round(c) / 100).toFixed(2).split('.'); return 'R$ ' + s[0].replace(/\B(?=(\d{3})+$)/g, '.') + ',' + s[1]; }
  function rd(x) { return Math.round(x); }
  /* total previsto pelo checkout, ou null quando não dá para prever (outro produto, plano desconhecido) */
  function predict(c) {
    var it = (c && c.items) || [], n = 0, t = 0, i, x;
    if (!it.length) return null;
    for (i = 0; i < it.length; i++) { x = it[i]; if (!POTE[x.variant_id || x.id]) return null; n += x.quantity; }
    for (i = 0; i < it.length; i++) {
      x = it[i];
      var sa = x.selling_plan_allocation, pid = sa && sa.selling_plan && sa.selling_plan.id, p = 0, u;
      if (pid) { if (!(pid in PLAN)) return null; p = PLAN[pid]; }
      /* preço cheio do pote: o "de" do plano; sem ele, o preço original do item */
      if (sa && sa.compare_at_price) u = sa.compare_at_price;
      else if (sa && sa.price) u = rd(sa.price / (1 - p / 10000));
      else u = x.original_price || x.price;
      if (!(u > 0)) return null;
      u -= rd(u * p / 10000);
      if (n >= 2) u -= rd(u * 1000 / 10000);
      if (n >= 3) u -= rd(u * 556 / 10000);
      t += u * x.quantity;
    }
    return { t: t, n: n };
  }
  function foot() { return D.querySelector('#right-drawer-slot .pb-safe-bottom'); }
  function btnHost(root) {
    var list = root.querySelectorAll('button,a,[name="checkout"]'), b = null;
    for (var i = 0; i < list.length; i++) { if (/finalizar|checkout/i.test(list[i].textContent || '') || list[i].getAttribute('name') === 'checkout') { b = list[i]; break; } }
    if (!b) return null;
    var h = b.closest('.push-btn') || b;
    return h.parentElement && h.parentElement.classList.contains('relative') && root.contains(h.parentElement) ? h.parentElement : h;
  }
  function paint(root, html) {
    var el = root.querySelector('.blu-ckt');
    if (!html) { if (el) el.parentNode.removeChild(el); return; }
    if (el && el._h === html) return;
    if (!el) {
      var h = btnHost(root); if (!h) return;
      el = D.createElement('p'); el.className = 'blu-ckt'; el.setAttribute('role', 'status');
      h.parentNode.insertBefore(el, h);
    }
    el.innerHTML = html; el._h = html;
  }
  var seq = 0, t = 0;
  function run() {
    var root = foot(); if (!root || !btnHost(root)) return;
    var my = ++seq;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (my !== seq) return;
        var root2 = foot(); if (!root2) return;
        var p = predict(c), cur = c && c.total_price;
        if (!p || !(cur > 0) || cur - p.t <= 100) { paint(root2, ''); return; }
        paint(root2, '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="8" cy="8" r="1.6"/></svg>' +
          '<span>No checkout fica <b>' + brl(p.t) + '</b> com o desconto progressivo de ' + p.n + ' potes.<small>O carrinho ainda não mostra esse desconto, ele entra no pagamento.</small></span>');
      })
      .catch(function () {});
  }
  function soon() { if (t) return; t = setTimeout(function () { t = 0; try { run(); } catch (e) {} }, 160); }
  function start() {
    soon();
    var slot = D.querySelector('#right-drawer-slot') || D.body;
    if ('MutationObserver' in window) new MutationObserver(function (ms) {
      /* ignora a própria linha para não entrar em ciclo */
      for (var i = 0; i < ms.length; i++) { var m = ms[i], tg = m.target; if (tg.nodeType === 1 && (tg.classList.contains('blu-ckt') || tg.closest && tg.closest('.blu-ckt'))) continue; var own = true, j, L = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes)); for (j = 0; j < L.length; j++) if (!(L[j].nodeType === 1 && L[j].classList.contains('blu-ckt'))) own = false; if (own && L.length) continue; soon(); return; }
    }).observe(slot, { childList: true, subtree: true });
    D.addEventListener('theme:update:cart', soon);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
